<template>
	<portal to="bottom-sheet" v-if="layout == 'Mobile'">
		<div class="wrapper" :data-open="state === 'open' ? 1 : 0">
			<div class="bg" @click="close"></div>
			<div
				ref="card"
				class="card"
				:data-state="isMove ? 'move' : state"
				:style="{ top: `${isMove ? y : calcY()}px` }"
			>
				<div class="pan-area" ref="pan">
					<div class="bar" ref="bar"></div>
				</div>
				<div class="contents" ref="contents">
					<slot></slot>
				</div>
			</div>
		</div>
	</portal>
	<modal :size="size" :show="true" @close="close" v-else>
		<template slot="modal-content">
			<slot />
		</template>
	</modal>
</template>

<script>
import Modal from "./Modal.vue";
export default {
	name: "BottomSheet",
	components: { Modal },
	props: {
		openY: {
			type: Number,
			default: 0.1,
		},
		halfY: {
			type: Number,
			default: 0.8,
		},
		defaultState: {
			type: String,
			default: "close",
		},
		size: {
			type: String,
			default: "auto",
			required: false,
		},
	},
	data() {
		return {
			mc: null,
			y: 0,
			startY: 0,
			isMove: false,
			state: this.defaultState,
			rect: {},
			showModal: true,
			layout: "Mobile",
		};
	},
	mounted() {
		let vm = this;
		vm.layout = window.innerWidth < 1024 ? "Mobile" : "Desktop";
		if (vm.layout != "Mobile") return;
		window.onresize = () => {
			vm.rect = this.$refs.card.getBoundingClientRect();
			vm.layout = window.innerWidth < 1024 ? "Mobile" : "Desktop";
		};
		console.log(this);

		vm.$nextTick(() => {
			// console.log("The refs are: ", vm.$refs);
			vm.rect = vm.$refs.card.getBoundingClientRect();
		});
		vm.$emit("has-mounted");
	},
	beforeDestroy() {
		window.onresize = null;
	},
	methods: {
		close() {
			this.$emit("close");
		},
		calcY() {
			let contentOffset = this.rect.height * this.openY;
			if (this.$refs.contents) {
				contentOffset =
					window.innerHeight -
					this.$refs.contents.getBoundingClientRect().height -
					40;
			}
			switch (this.state) {
				case "close":
					return this.rect.height;
				case "open":
					return contentOffset;
				case "half":
					return this.rect.height * this.halfY;
				default:
					return this.y;
			}
		},
		setState(state) {
			this.state = state;
		},
	},
};
</script>

<style lang="scss" scoped>
.wrapper {
	z-index: 999999999999;
	max-width: var(--app-width);
}
.wrapper[data-open="1"] {
	position: fixed;
	top: 0;
	left: 0;
}
.wrapper[data-open="1"] .bg {
	display: block;
	transition: display 0.3s, top 0.3s, bottom 0.3s, background 0.3s;
	position: fixed;
	top: 0;
	left: 50%;
	right: 50%;
	bottom: 0;
	background: rgba(0, 0, 0, 0.3);
	width: 100%;
	max-width: var(--app-width);
	transform: translateX(-50%);
}
.card {
	width: 100%;
	max-width: var(--app-width);
	transform: translateX(-50%);
	height: 100vh;
	position: fixed;
	background: var(--white);
	box-shadow: 0 -3px 4px rgba(0, 0, 0, 0.1);
	left: 50%;
	z-index: 999999999998;
}
.card[data-state="half"],
.card[data-state="open"],
.card[data-state="close"] {
	transition: top 0.3s ease-out;
}
.card[data-state="close"] {
	box-shadow: none;
}
.bar {
	width: 45px;
	height: 8px;
	border-radius: 14px;
	background: rgba(0, 0, 0, 0.3);
	margin: 0 auto;
	cursor: pointer;
}
.pan-area {
	padding: 12px 0;
}
.contents {
	overflow-y: auto;
	max-height: 100%;
	box-sizing: border-box;
	position: relative;
}
</style>
